import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';

import { categories } from '../data/general';

const Categories = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  };

  return (
    <div className="CategoriesList">
      <Container>
        <Row>
          <Col>
            <div className="CategoriesList-BoxWarp">
              <Slider {...settings}>
                {
                  categories.map((category, index) => (
                    <div key={index}>
                      <Link to={category.slug} className="CategoriesList-Item">
                        {category.icon}
                        <h5 className="CategoriesList-Item__Title">{category.name}</h5>
                      </Link>
                    </div>
                  ))
                }
              </Slider>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Categories;